import React from "react";
import Login from "../../../Components/Auth/Login";

const LoginPage = () => {
  return <Login />;
};

export default LoginPage;
